import { Court, CourtsPayload, Maybe } from "../../../generated";

export interface CourtState {
  allCourts: CourtsPayload['courts'],
  currentCourt: Maybe<Court>
}

export const courtInitialState: CourtState = {
  allCourts: [],
  currentCourt: null
};

export enum CourtActionType {
  SET_ALL_COURTS = 'setAllCourts',
  SET_CURRENT_COURT = "setCurrentCourt",
}

export type CourtAction =
  | { type: CourtActionType.SET_ALL_COURTS, allCourts: CourtsPayload['courts'] }
  | { type: CourtActionType.SET_CURRENT_COURT, currentCourt: Maybe<Court> }

export const courtReducer = (state: CourtState, action: CourtAction): CourtState => {
  switch (action.type) {
    case CourtActionType.SET_ALL_COURTS:
      return {
        ...state,
        allCourts: action.allCourts
      }

    case CourtActionType.SET_CURRENT_COURT:
      return {
        ...state,
        currentCourt: action.currentCourt
      }
    default:
      return state;
  }
};
